import React from "react";
import { Snackbar, SnackbarContent } from "@material-ui/core";

export const MaxFileSizeSnackbar = props => {
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
            }}
            autoHideDuration={6000}
            open={props.fileMaxSizeSnackbar}
            onClose={() => {
                props.setState({ fileMaxSizeSnackbar: false });
            }}
        >
            <SnackbarContent
                style={{
                    backgroundColor: "red",
                    color: "white",
                    zIndex:400
                }}
                message="Image Size Too Large, Please Choose an Image Under 1MB"
            />
        </Snackbar>
    );
};
